import Header from '../components/Header'
import Footer from '../components/Footer'
import { atom, useAtom } from 'jotai'
// import Image from 'next/image'
// import Link from 'next/link'
import { HashLink as Link } from 'react-router-hash-link';
// import { NavHashLink } from 'react-router-hash-link';
import {  useLocation, useParams, useNavigate } from "react-router-dom";
//import TimelineThumb from '../components/TimelineNavigation'
import { GalleryItemDetail, PreloadedGalleryItemDetail } from '../components/GalleryItemDetail'
import { useState, useEffect, useRef } from 'react'
import parse from 'html-react-parser';

import {Helmet} from "react-helmet";

//import {priceAtom, messageAtom, productAtom, textAtom} from '../atoms/atom.config.js'
import {isSmallAtom, slideIndexAtom, isThreeFlagLoadingAtom, isShowingHelpAtom, isContrastAtom, isAnimationsPausedAtom} from '../atoms/atom.config.js'
import useDeviceSize from '../components/useDeviceSize';
//import {priceAtom, messageAtom, productAtom, textAtom,titleAtom} from '../atoms/atom.config.js'
//import { FEATURES, mobileWidth } from '../constants';
import { mobileWidth, SECTIONS, FEATURES, API,MEDIA } from '../constants';

// svgr: https://react-svgr.com/docs/next/
// import ScrollDownIcon from '../assets/icons/button_close.svg'

// assets
// import notesImage from '../assets/images/default_thumb.jpg'
// import notesImage from './default_thumb.jpg'
// import timelineImage from '../assets/icons/icon_object.svg'
import {OutlineButtonTextIcon, OutlineButtonTextIconAlt, ButtonTextIcon} from '../components/Button'
import SlideFull from '../components/Slides'
import { MediaItem } from "../components/VideoItem";
import { ModalOverlay } from "../components/ModalOverlay";

// assets
import logoImage from '../assets/images/default_thumb.jpg'
import scrollDownIcon from '../assets/icons/icon_scrolldown.svg'
import scrollObjectIcon from "../assets/icons/icon_object.svg"
import flipIcon from "../assets/icons/icon_flip.svg"
import culturalIcon from "../assets/icons/icon_cultural_large.gif"
import culturalIconPause from "../assets/icons/icon_cultural_large.png"
import culturalIconSm from "../assets/icons/icon_cultural.svg"
import securityIcon from "../assets/icons/icon_security_large.gif"
import securityIconPause from "../assets/icons/icon_security_large.png"
import securityIconSm from "../assets/icons/icon_security.svg"
import scrollerDotIcon from "../assets/icons/icon_dot_page.svg"
import scrollerDotActiveIcon from "../assets/icons/icon_dot_current_page.svg"
// preload options icons
import optionsIcon from '../assets/icons/icon_options.svg'
import optionsIconHover from'../assets/icons/icon_options_h.svg'
import closeOptionsIcon from '../assets/icons/icon_close_wht.svg'
import closeOptionsIconHover from '../assets/icons/icon_close_wht_h.svg'
import pauseIcon from '../assets/icons/icon_pause.svg'
import pauseIconOff from '../assets/icons/icon_pause_off.svg'
import pauseIconHover from'../assets/icons/icon_pause_h.svg'
import pauseIconHoverAlt from'../assets/icons/icon_pause_off_h.svg'
import contrastIcon from '../assets/icons/icon_contrast.svg'
import contrastIconOff from '../assets/icons/icon_contrast_off.svg'
import contrastIconHover from '../assets/icons/icon_contrast_h.svg'
import contrastIconHoverAlt from '../assets/icons/icon_contrast_alt_h.svg'
import soundIcon from '../assets/icons/icon_sound.svg'
import soundIconOff from '../assets/icons/icon_sound_off.svg'
import soundIconHover from '../assets/icons/icon_sound_h.svg'
import soundIconHoverAlt from '../assets/icons/icon_sound_off_alt_h.svg'
//preload logo icons
import logoIcon from '../assets/icons/logo_desktop.svg'
import logoIconHover from '../assets/icons/logo_desktop_h.svg'

// components
import {VideoBackground,MediaBackground,ImageBackgroundFixed,VideoBackgroundFixed} from '../components/VideoBackground';
//import bgVideo from '../assets/videos/00_Introduction.mp4';
import {SlidesScroller} from '../components/SlidesScroller'
import {ThreeFlag} from '../components/ThreeFlag'
import Spinner from '../components/Spinner'
import { PreloadedImages } from '../components/PreloadedImages'

import inobounce from "inobounce"

export default function Note(props) {




  // const [deviceWidth, deviceHeight] = useDeviceSize();
  const elementRef = useRef(null);
  const element3Ref = useRef(null);
  const slidesScrollerRef = useRef(null)
  const threeFlagRef = useRef(null)
  const [flipImage, setFlipImage] = useState(false)
  const [progressIcons, setProgressIcons] = useState([]) //['Ada Lovelace', 'Grace Hopper', 'Margaret Hamilton'];
  const [isSmall, setIsSmall] = useAtom(isSmallAtom);
  //const [isThreeFlagLoading, setIsThreeFlagLoading] = useAtom(isThreeFlagLoadingAtom);
  const [isThreeFlagLoading, setIsThreeFlagLoading] = useState(true); // switched to local state now, and passing this

  const [isContrast, setIsContrast] = useAtom(isContrastAtom);
  const [isAnimationPaused, setAnimationPaused] = useAtom(isAnimationsPausedAtom);

  //const locationParams = useParams(); //useLocation();
  const location = useLocation();
  const history = useNavigate();

  // gallery zoom item moved this outside the carousel
  const [isZoom, setIsZoom] = useState(false);
  const [zoomItem, setZoomItem] = useState(null);

  // credits
  const [isCredits, setIsCredits] = useState(false);
  const [isHelp, setIsHelp] = useAtom(isShowingHelpAtom);
  //const [helpData, setHelpData] = useState(null);
  
  // a custom copy of the slide index
  const [customSlideEventIndex, setCustomSlideEventIndex] = useState(0);

  // preload the whole page including images + videos before displaying content
  const [isPreloading, setIsPreloading] = useState(true);
  //const [loadedCount, setLoadedCount] = useRef(0);
  const loadedCount = useRef(0)
  const loadedCountMax = useRef(0)
  const [preloadedCount, setPreloadedCount] = useState(0);

  //const [isNoteFlipped, setIsNoteFlipped] = useState(false);

  //const slidesIndex = 0; // test use this as a property and pass to slides
  //console.log("slidesIndex", slidesIndex)

  // just forwarding the same method to the slidesscroller
//   const gotoSlide = (slideIndex) => {
//     console.log("gotoSlide", slideIndex, slidesScrollerRef, slidesScrollerRef.current)
//     //slidesScrollerRef.current.gotoSlide(slideIndex);
//     slidesScrollerRef.current.gotoSlide(slideIndex)
//   };
//   const gotoNextSlide = () => {
//     //slidesScrollerRef.current.gotoNextSlide();
//   };

  const getParsed = (data) => {
    return parse(data)
  }

  const getBackgroundCredits = (field) => {
    const credits = props.credits; 
    console.log(credits)
    if(credits) {
      for (let i = 0; i < credits.length; i++) {
        if(credits[i].note == props.note) {
          return parse(credits[i][field])
        }
      }
    }
    return "..."
  };

  const getCulturalFeaturesDescription = () => {
    // iterate the features and get the 
    const features = props.features; //[FEATURES.CULTURAL]
    //console.log("getCulturalFeaturesData", features)
    if(features) {
      for (let i = 0; i < features.length; i++) {
        //if(features[i].note == props.note) {
        if(features[i].note == props.note && features[i].title == FEATURES.CULTURAL) {
          return parse(features[i].description)
        }
      }
    }
    return "..."
  };

  const getSecurityFeaturesDescription = () => {
    // iterate the features and get the 
    const features = props.features;//[FEATURES.SECURITY]
    //console.log("getSecurityFeaturesData", features)
    if(features) {
      for (let i = 0; i < features.length; i++) {
        //if(features[i].note == props.note) {
        if(features[i].note == props.note && features[i].title == FEATURES.SECURITY) {
          return parse(features[i].description)
        }
      }
    }
    
    return "..."
  };

  const getCulturalFeaturesGalleryData = () => {
    const data = []; // props.data;
    if(props.data) {
      for (let i = 0; i < props.data.length; i++) {
        if(props.data[i]["themes"] == FEATURES.CULTURAL_DATA_LABEL) {
          data.push(props.data[i]);
        }
      }
    }
    return data;
  };

  const getAllGalleryData = () => {
    const data = []; // props.data;
    if(props.data) {
      for (let i = 0; i < props.data.length; i++) {
        if(props.data[i]["themes"] == FEATURES.CULTURAL_DATA_LABEL || props.data[i]["themes"] == FEATURES.SECURITY_DATA_LABEL) {
          data.push(props.data[i]);
        }
      }
    }
    return data;
  };

  const getCulturalFeaturesGalleryCount = () => {
    let count = 2;
    let slidesCount = getCulturalFeaturesGalleryData().length
    return count+slidesCount
  };

  const getSecurityFeaturesGalleryData = () => {
    const data = []; // props.data;
    if(props.data) {
      for (let i = 0; i < props.data.length; i++) {
        if(props.data[i]["themes"] == FEATURES.SECURITY_DATA_LABEL) {
          data.push(props.data[i]);
        }
      }
    }
    return data;
  };

  const getSecurityFeaturesGalleryCount = () => {
    let count = 3;
    let slidesCount1 = getCulturalFeaturesGalleryData().length
    let slidesCount2 = getSecurityFeaturesGalleryData().length
    return count+slidesCount1+slidesCount2+1
  };
  const getTotalSlidesCount = () => {
    let count = getSecurityFeaturesGalleryCount();
    //console.log("getTotalSlidesCount", count)
    return count
  };

  const getCulturalFeaturesGalleryId = (index) => {
    //let total = getCulturalFeaturesGalleryCount()
    return "slide"+String(2+index)
  };
  const getSecurityFeaturesGalleryId= (index) => {
    let total = getCulturalFeaturesGalleryCount()
    return "slide"+String(total+1+index)
  };
  const getSecurityFeaturesGalleryHomeId = () => {
    let total = getCulturalFeaturesGalleryCount()
    //return "slide"+String(total+index)
    return "slide"+String(total)
  }
  const getSecurityFeaturesGalleryHomeIndex = () => {
    let total = getCulturalFeaturesGalleryCount()
    //return "slide"+String(total+index)
    return total
  }
  const getLastId = () => {
    let total = getSecurityFeaturesGalleryCount()
    //return "slide"+String(total+index)
    return "slide"+String(total-1)
  }
  const getValidIndexRange = (index, compareIndex) => {
    // returns true for index-1, index and index+1
    // eg. index=1||index=2||index==3, compareIndex=2, true
    //console.log("getValidIndexRange", index, compareIndex)
    // return (index-1 == compareIndex) || (index == compareIndex) || (index+1 == compareIndex) 
    return (index == compareIndex)
  } 

  const getValidIndexRangeGalleryOnly = (index) => {
    let valid = index >= 2 && index != getSecurityFeaturesGalleryCount()-1 && index != getCulturalFeaturesGalleryCount();
    // let valid = index >= 1 && index != getSecurityFeaturesGalleryCount()-1 && index != getCulturalFeaturesGalleryCount();
    //console.log("getValidIndexRangeGalleryOnly", index, getCulturalFeaturesGalleryCount(), valid);
    return valid;
  }

  const getValidIndexRangeGalleryOnlyPreAndPost = (index) => {
    // let valid = index >= 2 && index != getSecurityFeaturesGalleryCount()-1 && index != getCulturalFeaturesGalleryCount();
    let valid = index >= 1 && index != getSecurityFeaturesGalleryCount();// && index != getCulturalFeaturesGalleryCount()+1;
    //console.log("getValidIndexRangeGalleryOnly", index, getCulturalFeaturesGalleryCount(), valid);
    return valid;
  }

  const updateUrlHistory = (appendOverlayFlag) => {
    if(false) {
      const sid = location.pathname.split(":");
      console.log("updateUrlHistory", sid)
      if(sid.length > 0) {
        // appending :1 to the current url
        const url = sid[0]+":"+sid[1]+((appendOverlayFlag) ? ":1" : "");
        history(url); //, {state:{slide:currentSlideIndex.current}});
      }
      
      //console.log("updating url history:", sid, url)
      //window.history.pushState(null, "", url) //"/pathname/goes/here")
      //{ replace: true, state: { bookName: "Fake Title" }}
      //history(url, {state:{slide:currentSlideIndex.current}});
    }
    
  };

  const onZoomOpenEvent = (event, param) => {
    //console.log("handleScrollTest", isScrolling, event)
    console.log("onVideoZoomEvent (note)", event, param)
    if(param.type === "animation") {
      // ignore gif animations
      console.log("gif animation detected! ignore zoom")
      return
    }
    // FIXME: need to get the current selected item
    setZoomItem(param)
    setIsZoom(true)

    // TEST: update the url by appending :1 to whatever it already is
    updateUrlHistory(true)

    // disable main body scroll (if not already disabled)
    if(!isSmall) toggleBodyScroll(true, false)

  }
  const onZoomCloseEvent = event => {
    console.log("onZoomCloseEvent (note)", event, isSmall)
    setIsZoom(false)

    // TEST: update the url by appending :1 to whatever it already is
    updateUrlHistory(false)

    // re-enable body scroll (if not already disabled)
    if(!isSmall) toggleBodyScroll(false, false, true)
    else {
      // if we are mobile we need to force the body scroll back OFF- as the library reenabled internally
      //toggleBodyScroll(true, true, true)
      setTimeout(() => {
        toggleBodyScroll(true, true, true)
      },10);
      //toggleBodyScroll(true, true)
    }

    // if(slidesScrollerRef.current) {
    //   console.log("FORCE scroll to last window pos.y");
    //   slidesScrollerRef.current.forceToLastScrollPosMod()
    // }
  };

  const onCreditsOpenEvent = (event) => {
    console.log("onCreditsOpenEvent (note)", event)
    setIsCredits(true)

    // disable main body scroll (if not already disabled)
    if(!isSmall) toggleBodyScroll(true, true)

  };

  const onCreditsCloseEvent = event => {
    console.log("onCreditsCloseEvent (note)", event)
    setIsCredits(false)

    // re-enable body scroll (if not already disabled)
    if(!isSmall) toggleBodyScroll(false, true)
    else {
      // if we are mobile we need to force the body scroll back OFF- as the library reenabled internally
      setTimeout(() => {
        toggleBodyScroll(true, true)
      },10);
      //toggleBodyScroll(true, true)
    }
  };

  // custom help overlay (copy+paste into note.js+home.js as well)
  // - note this is just a global flag that is triggered via the nav in app.js. we need to 'listen' when it changes so we can add/remove the scroll listeners
  const onHelpOpenEvent = (event) => {
    console.log("onHelpOpenEvent (note)", event)
    //setIsHelp(true) // this is already flagged via app.js

    // disable main body scroll (if not already disabled)
    if(!isSmall) toggleBodyScroll(true, true)

  };

  const onHelpClosed = (e) => {
    console.log("onHelpClosed",e)
    setIsHelp(false)

    // re-enable body scroll (if not already disabled)
    if(!isSmall) toggleBodyScroll(false, false)
    else {
      // if we are mobile we need to force the body scroll back OFF- as the library reenabled internally
      //toggleBodyScroll(true, true, true)
      setTimeout(() => {
        toggleBodyScroll(true, true)
      },10);
      //toggleBodyScroll(true, true)
    }
  }

  const onFlipFlag = (e) => {
    //() => threeFlagRef.current.swapMaterialMod()
    if(threeFlagRef.current) {
      threeFlagRef.current.swapMaterialMod()
    }
    //console.log("flipFlag isNoteFlipped:", isNoteFlipped)
    //setIsNoteFlipped(!isNoteFlipped)
  }

  // FIXME: toggling this forces the window scroll position to 0,0
  // it seems automatically managed correctly using the zoom, but the credist is NOT
  const toggleBodyScroll = (off, allowToggleBodyScroll=false, forceDisableBodyScroll=false) => {
    // if(on) {
    //   //document.body.classList.add("no-scroll")
    //   document.body.style.overflow = "hidden"
    // } else {
    //   document.body.style.overflow = "auto"
    // }
    const html = document.querySelector("html");
    console.log("note toggleBodyScroll", off);//), slidesScrollerRef.current, html)
    if (html) {
      //if(allowToggleBodyScroll) document.body.style.overflowY = off ? "hidden" : "unset";
      //if(allowToggleBodyScroll) html.style.overflow = off ? "hidden" : "auto";
      if(allowToggleBodyScroll) {
        
        html.style.overflow = off ? "hidden" : "unset";
        html.style.overflowY = off ? "hidden" : "unset";

        
      }
      if(slidesScrollerRef.current) {
        slidesScrollerRef.current.toggleScrollMod(off)
      }

      // FIXME: when using the pan/zoom image it adds scroll to the BODY not the html (this gets 'unset' in the VideoItem destructor though)
      // ALSO the scroll has been reset to 0,0- we need to go back to original position
      // FIXED!!! just disabled the auto body scroll in tVideoItem
      if(forceDisableBodyScroll) {

        //document.body.style.overflow = "unset";// off ? "hidden" : "unset";
        //document.body.style.overflowY = "unset";// off ? "hidden" : "unset";
        //console.log("FORCE disabling overflow on doc.body");

        //window.scrollTo({ top: 1000, left: 0, behavior: 'instant' });
        // if(slidesScrollerRef.current) {
        //   console.log("FORCE scroll to last window pos.y");
        //   slidesScrollerRef.current.forceToLastScrollPosMod()
        // }
      }
    }
  };

  const onSlidesScrollerSlideChanged = evt => {
    console.log("onSlidesScrollerSlideChanged", evt)
    setCustomSlideEventIndex(evt.detail)
  };
  const onSlidesScrollerSlideBegin = evt => {
    console.log("onSlidesScrollerSlideBegin", evt)
    //setCustomSlideEventIndex(evt.detail)
  };

  const updatePreloadCounter = (path) => {
    // if all assets loaded then toggle the preloader
    let count = loadedCount.current+1
    loadedCount.current = count;
    //setLoadedCount(count)
    let mainAssetCount = 5; // see list below (5)
    let culturalAssetCount = 0;
    let securityAssetCount = 0;
    if(props.data) {
      culturalAssetCount = getCulturalFeaturesGalleryData().length
      securityAssetCount = getSecurityFeaturesGalleryData().length
    }
    let minItemsPreloadedCount = mainAssetCount+culturalAssetCount+securityAssetCount
    loadedCountMax.current = minItemsPreloadedCount
    console.log("updatePreloadCounter:",count, "/", minItemsPreloadedCount, path)
    setPreloadedCount(count)

    if(count >= minItemsPreloadedCount && isPreloading) {
      //console.log("PRELOAD COMPLETE!", count)
      //setIsPreloading(false)
      // DEBUG LOADING HERE
      //setTimeout(() => {
        setIsPreloading(false)
        console.log("PRELOAD COMPLETE", count)
      //},5000);
    }

    /* list of items that need to be preloaded (data.json is also preloaded with this list):
    0. fixed video background for slides 2+: props.media.background
    1. slide 0 clouds video: props.media.background_clouds
    2. slide 0 three flag images x2: ThreeFlag
    3. slide 1 cultural features video: props.media.background_cultural
    4. slide X security features video:props.media.background_security
    */
  };
  

  //console.log("note state changed?")
  // FIXME: this is re-rendering/flickering with the css group in routes when fading out
  useEffect(() => {


    //setTimeout(() => {
      // DEBUG TIMEOUT
    

    // because we are using different icons- need to build array with the different types
    // UPDATE: waiting for both data + features properties before running the calls
    if(props.data && props.features) {
      //console.log("force window scroll top...")
      //window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
      if(inobounce.isScrollSupported) {
        // ios only (android is disabling the div scroll)
        inobounce.enable();
      }
      //inobounce.enable();
      //console.log("inobounce", inobounce)

      // FIXME: need to disable 'body/doc scroll' for mobile
      //toggleBodyScroll(true)
      //toggleBodyScroll(true, true)
      
      let icons = [];
      let count = getSecurityFeaturesGalleryCount();
      let securityIndex = getSecurityFeaturesGalleryHomeIndex();
      let cultData = getCulturalFeaturesGalleryData();
      let secData = getSecurityFeaturesGalleryData();
      let iconTitles = [];

      // TODO: get name field from data an apply to alt text
      const iconDefault = {icon:scrollerDotIcon,active:scrollerDotActiveIcon,size:8,alt:''}
      const iconCulture = {icon:culturalIconSm,active:culturalIconSm,size:18,alt:''}
      const iconSecurity = {icon:securityIconSm,active:securityIconSm,size:14,alt:''}
      //const icons = [iconDefault, iconCulture, iconDefault, iconDefault, iconSecurity,iconDefault,iconDefault]; //"../assets/icons/icon_dot_page.svg"];
      //var 
      var j=0; //cultural
      var k=0; //security
      for (let i = 0; i < count; i++) {
        var iconObj = (i == 1) ? iconCulture : ((i == securityIndex) ? iconSecurity : iconDefault);
        // want to add a custom alt text to the progress icons - need to pull titles from data, and also copy the objects with Obj.assign https://stackoverflow.com/questions/728360/how-do-i-correctly-clone-a-javascript-object
        //iconObj.alt = "slide"+i;
        if( i == 0) {
          // slide 0 = $X Banknote
          iconObj.alt = props.note + " Banknote";
        } else if( i == 1) {
          iconObj.alt = FEATURES.CULTURAL;
        } else if( i == securityIndex) {
          iconObj.alt = FEATURES.SECURITY;
        } else if( i == count-1) {
          iconObj.alt = "Explore another banknote";
        } else if(i > securityIndex ) {
          // security
          if(secData) {
            //console.log("yo", i, k, secData[k]); //props.data.name
            iconObj.alt = secData[k].name;
            k++;
          }
          
        } else if(i > 1) {
          // cultural
          if(cultData) {
            //console.log("mo", i, j, cultData[j]);
            iconObj.alt = cultData[j].name;
            j++;
          }
          
        }

        icons.push( Object.assign({}, iconObj) ); // iconObj ); //(i == 1) ? iconCulture : ((i == securityIndex) ? iconSecurity : iconDefault));
        //console.log("progress icons:", i)

        //console.log("iconObj", i, iconObj)
      }    
      setProgressIcons(icons);

      //setIsThreeFlagLoading(true)

      // disable scrolling
      if(isSmall) {
        toggleBodyScroll(true, true)
      } else {
        toggleBodyScroll(false)
      }

      console.log(".................................................", props.note, isPreloading, props.data);
      console.log("Note props re-render:", props); 

    }
    

    //},10000);

    //, count, securityIndex, icons.length);//, "locationParams:", locationParams); //, getSecurityFeaturesGalleryCount())
  }, [props]);

  // listening to custom event from slidesScroller when animation/slide completes
  // this fires once only at launch
  useEffect(() => {
    // listen to custom events: https://blog.logrocket.com/using-custom-events-react/
    document.addEventListener("onSlideAnimationComplete", onSlidesScrollerSlideChanged);
    //document.addEventListener("onSlideAnimationBegin", onSlidesScrollerSlideBegin);
    
    console.log("added custom event listener")

    // reset the preloading cache counter
    // setLoadedCount(0)
    loadedCount.current = 0
    loadedCountMax.current = 1

    console.log("\n-----------------------------------------------", props.note, isPreloading);

    return () => {
      // listen to custom events: https://blog.logrocket.com/using-custom-events-react/
      console.log("removing custom event listener")
      document.removeEventListener("onSlideAnimationComplete", onSlidesScrollerSlideChanged);
      //document.removeEventListener("onSlideAnimationBegin", onSlidesScrollerSlideBegin);
    };
  }, []);

  useEffect(() => {
    console.log("Note isThreeFlagLoading:", isThreeFlagLoading);

    // setTimeout(() => {
      //setIsPreloading(false)
      //console.log("PRELOAD COMPLETE")
    // },3000);

    if(!isThreeFlagLoading) {
      updatePreloadCounter("three flagx2")
    }
    
    
  }, [isThreeFlagLoading]);

  // listen to the global navigation help flag
  // if we toggle to small/mobile we need to disable body scroll
  useEffect(() => {
    console.log("isHelp changed (note):", isHelp, "prelaoding:", isPreloading)
    if(isHelp) {
      if(!isPreloading) onHelpOpenEvent(null)
      else {
        console.log("attempt to open helpbefore preload complete - cancel and set flag back to false")
        setIsHelp(false);
      }
    }
  }, [isHelp]);

  // if we toggle to small/mobile we need to disable body scroll
  /*useEffect(() => {
    console.log("isSmall changed (note):", isSmall)

    // FIXME: need to disable 'body/doc scroll' for mobile
    //toggleBodyScroll(true)
    //toggleBodyScroll(true, true)
    if(isSmall) {
      toggleBodyScroll(true, true)
    } else {
      toggleBodyScroll(false)
    }

    // document.getElementById('test').scrollTop =0;

  }, [isSmall]);*/

  // useEffect(() => {
  //   console.log("preloading assets...")
  //   //props.media.background_security
  //   const preloadedImages = [culturalIcon, securityIcon];
  //   for (const img of preloadedImages) {
  //     const imageElement = new Image();
  //     imageElement.src = img;
  //     console.log("Preloaded image", img)
  //   }
  //   /*const preloadedVideos = [props.media.background, props.media.background_clouds];
  //   for (const vid of preloadedVideos) {
  //     var viElement;
  //       try {
  //         viElement = new Video();
  //     } catch(e) {
  //       viElement = document.createElement('video');
  //     }
  //     //const viElement = new Video();
  //     viElement.src = vid;
  //     console.log("Preloaded image", vid)
  //   }*/

  // }, []);

  // // reset to top of page when broswer resize
  // useEffect(() => {
  //   console.log("notes w/h changed:", deviceWidth,deviceHeight)
  //   window.scrollTo({ top: 0, left: 0, behavior: 'instant' });

  // }, [deviceWidth,deviceHeight]);

  const imageBgStyles = {
    'zIndex': 0,
  }

  // const getThreeFlagLoadingCN = () => {
  //   return 
  // };

  const cnGrayscaleFilters = `${(isSmall) ? '' : 'grayscale transition duration-500 hover:grayscale-0 hover:scale-105 focus:grayscale-0 focus:scale-105'}`;
  const cnNoteSize = `${(isSmall) ? 'basis-96 ' : 'basis-1/4 '+cnGrayscaleFilters}`; //'w-[22rem] sm:w-[12rem] md:w-[14rem] lg:w-[22rem] ';//
  const cnBottomBuffer = `${(isSmall) ? 'h-[100px]' : 'h-[0px]'}`; //'w-[22rem] sm:w-[12rem] md:w-[14rem] lg:w-[22rem] ';//
  return (
    <>
      <Helmet>
                {/* <meta charSet="utf-8" /> */}
                {/* <title>My Title</title> */}
                {/* <link rel="canonical" href="http://mysite.com/example" /> */}
                <link rel="preload" as="video" href={props.media.background} />
                <link rel="preload" as="image" href={props.media.background_poster} />
                <link rel="preload" as="video" href={props.media.background_clouds} />
                <link rel="preload" as="image" href={props.media.background_clouds_poster} />
                <link rel="preload" as="video" href={props.media.background_cultural} />
                <link rel="preload" as="image" href={props.media.background_cultural_poster} />
                <link rel="preload" as="video" href={props.media.background_security} />
                <link rel="preload" as="image" href={props.media.background_security_poster} />
                
                <link rel="preload" as="image" href={culturalIcon} />
                <link rel="preload" as="image" href={securityIcon} />
                <link rel="preload" as="image" href={optionsIcon} />
                <link rel="preload" as="image" href={optionsIconHover} />
                <link rel="preload" as="image" href={closeOptionsIcon} />
                <link rel="preload" as="image" href={closeOptionsIconHover} />
                <link rel="preload" as="image" href={pauseIcon} />
                <link rel="preload" as="image" href={pauseIconOff} />
                <link rel="preload" as="image" href={pauseIconHover} />
                <link rel="preload" as="image" href={pauseIconHoverAlt} />
                <link rel="preload" as="image" href={contrastIcon} />
                <link rel="preload" as="image" href={contrastIconOff} />
                <link rel="preload" as="image" href={contrastIconHover} />
                <link rel="preload" as="image" href={contrastIconHoverAlt} />
                <link rel="preload" as="image" href={soundIcon} />
                <link rel="preload" as="image" href={soundIconOff} />
                <link rel="preload" as="image" href={soundIconHover} />
                <link rel="preload" as="image" href={soundIconHoverAlt} />
                <link rel="preload" as="image" href={logoIcon} />
                <link rel="preload" as="image" href={logoIconHover} />

                {/* BASE_API+props.data.note_feature_filename */}
      </Helmet>

      <div className='absolute block top-0 left-0 w-full h-full' id={props.note+"_"}>

        {/* main page preloader- needs to preload ALL content including background image */}
        { isPreloading && 
          <div className='absolute h-full w-screen z-30'  >
            <Spinner icon={props.spinner} text={'Loading '+(props.note)+' content...'} counter={preloadedCount} countermax={loadedCountMax}/>
            {/* <p className='absolute'>Loading content for {props.note}</p> */}
          </div>
        }

        {/* <ImageBackgroundFixed url={props.media.background_clouds_poster} poster={null}/> */}

        {/* main content */}
        <div className={ (isPreloading) ? 'invisible' : 'visible' } >
        {/* onClick={() => props.animateToSlideId(index)} */}
        {/* <Header test={"ok"} onMenuClicked={() => onMenuClicked()}/>       */}
          {/* <VideoBackground url={bgVideo}  /> */}

        {/* adding the fixed image background from the FIRST slide for nice transitions */}
          {/* { (customSlideEventIndex == 0) && */}
          {/* <ImageBackgroundFixed url={props.media.background_clouds_poster} poster={null}/> */}
          {/* } */}
          
        { props.data != null && <>
          {
            // (slidesScrollerRef.current && slidesScrollerRef.current.getCurrentSlideIndexFromControlsMod() > 0) &&
            // wait for the 3rd slide to preload before showing the background video
            // element3Ref.current && customSlideEventIndex >= 2) || 
            // (getValidIndexRangeGalleryOnly(customSlideEventIndex) ) &&
            // <VideoBackgroundFixed url={props.media.background} poster={props.media.background_poster} spinner={props.spinner} />

            // this might cause issues if we load/play even though not using until slide3!
            <div className={getValidIndexRangeGalleryOnlyPreAndPost(customSlideEventIndex) ? 'visible' : 'invisible'} >
            <VideoBackgroundFixed url={props.media.background} poster={props.media.background_poster} spinner={null} npreloader={true} preloadCB={updatePreloadCounter} overlay={isContrast ? props.media.overlay : null} />
            </div>

            
          }
          <SlidesScroller id={props.note} className='' ref={slidesScrollerRef} firstSlide={elementRef} slideCount={getTotalSlidesCount()} progressIcons={progressIcons}>

              {/* main slide landing page */}
              {/* <div className='flex flex-col min-h-displayNoNavHt items-center justify-center text-center bg-slate-400'> */}
              {/* <div id="scrollWrapper" className="overflow-y-auto overflow-x-hidden w-full h-screen relative"> */}
              <SlideFull id="slide0" ref={elementRef} className=''>
                {/* optional background image/video */}
                {/* <div className='absolute h-displayHt w-screen' style={imageBgStyles}>
                  <img src={props.media.background} className='h-full w-full object-cover relative' alt=""  />
                </div> */}
                {/* // customSlideEventIndex == 0 && <> */}
                
                {/* <MediaBackground url={props.media.background_clouds_poster} poster={null} spinner={null} npreloader={true} /> */}
                <div className={(isPreloading) ? 'invisible' : 'visible animate-fadein block absolute h-full top-0 left-0'}>
                <MediaBackground url={props.media.background_clouds} poster={props.media.background_clouds_poster} spinner={null} npreloader={true} preloadCB={updatePreloadCounter} overlay={isContrast ? props.media.overlay : null} />               
                </div>
                {getValidIndexRange(customSlideEventIndex, 0) ? <>
                <div className={'z-10 '+((isThreeFlagLoading) ? 'invisible' : (isPreloading) ? 'invisible' : 'visible')}>
                  <div className={((isPreloading) ? '' : 'animate-slidexFadeinDelayA ')}>
                      <h1 className="text-4xl md:text-4xl lg:text-6xl xl:text-6xl 2xl:text-6xl font-bold ">
                      {/* $5 Banknote <TimelineThumb src={notesImage} alt="img" />         */}
                      {/* {slidesScrollerRef && slidesScrollerRef.current.getCurrentSlideIndexFromControlsMod()} */}
                      {props.note} Banknote
                      </h1>
                      {/* <div className="mt-1 font-bold cursor-pointer" onClick={() => setFlipImage(!flipImage)}> */}
                      <div className="mt-1 font-bold cursor-pointer opacity-100 transition duration-200 " >
                        <button className="text-xl underline decoration-2 underline-offset-8 transition duration-500 decoration-white/[0.0] hover:decoration-white/[1.0]" onClick={onFlipFlag}>
                          <div >View other side <img className="inline ml-2" src={flipIcon} alt="View other side" width={18} height={18} /></div>
                        </button>
                      
                      </div>   
                  </div> 
                  <div className={'mt-6 block '+((isPreloading) ? '' : 'animate-slidexFadeinDelayB ')} >
                          {/* <Image src={notesImage} alt="Vercel Logo" width={820} height={410} /> */}
                          {/* <img src={ (flipImage) ? props.media.note_reverse : props.media.note} className='w-[45rem] relative' alt="Vercel Logo" width="820px" height="410px" /> */}
                          {/* {isAnimationPaused ? 
                          <div className={isSmall ? "px-[40px]" : "animate-fadeinSlow"} >
                            {isNoteFlipped ? <img className="relative animate-fadeinSlow" src={ props.media.note} alt="Flag" />
                            : <img className="block relative animate-fadeinSlow" src={ props.media.note_reverse } alt="Flag2" />
                            }
                            
                          </div>
                          : 
                          <ThreeFlag ref={threeFlagRef} stateChanger={setIsThreeFlagLoading} src={props.media.note} srcflip={props.media.note_reverse} size={props.media.note_size} className='w-[45rem] relative'></ThreeFlag>
                          } */}
                          {/* {isNoteFlipped ? 
                          <div className={isSmall ? "px-[40px]" : "animate-slidexFadeinDelayA"} >
                            <img className="relative animate-fadeinSlow" src={ props.media.note} alt="Flag" />
                          </div>
                            : 
                            <div className={isSmall ? "px-[40px]" : "animate-slidexFadeinDelayA"} >
                              <img className="block relative animate-fadeinSlow" src={ props.media.note_reverse } alt="Flag2" />
                            </div>
                          } */}
                            <ThreeFlag ref={threeFlagRef} stateChanger={setIsThreeFlagLoading} src={props.media.note} srcflip={props.media.note_reverse} size={props.media.note_size} className='w-[45rem] relative'></ThreeFlag>
                          {/* </div> */}
                          {/* {isThreeFlagLoading ? <div>LOADING</div> : <div></div>} */}
                          
                  </div>

                  <div className={'flex flex-row flex-wrap items-center justify-center gap-x-2 mt-6 pb-[4rem] px-[10px] '+((isPreloading) ? '' : 'animate-slidexFadeinDelayC ')}>
                      {/* <Link href="#slide1" scroll={false}> */}
                      <OutlineButtonTextIcon text="View cultural features" icon={culturalIconSm} iconAlt="View cultural features" iconSize="32" onClick={() => slidesScrollerRef.current.gotoSlideMod(1)}/>
                      {/* </Link> */}
                      <OutlineButtonTextIconAlt text={parse("View design<br/>and security features")} icon={securityIconSm} iconAlt="View design and security features" iconSize="22" onClick={() => slidesScrollerRef.current.gotoSlideMod(getSecurityFeaturesGalleryHomeIndex())}/>
                  </div>
                </div>
                { isThreeFlagLoading &&
                <div className='absolute h-full w-screen'>
                  <Spinner icon={props.spinner}/>
                </div>
                }
                </> : 
                <div className='absolute h-full w-screen'>
                  <Spinner icon={props.spinner}/>
                </div>}     
                {/* <div className='absolute h-full w-screen'>
                {customSlideEventIndex} : {(getValidIndexRange(customSlideEventIndex, 0)) ? 'valid' : 'invalid'}      
                </div> */}
              </SlideFull>
              {/* </div> */}

              {/* slides for cultural features */}
              {/* <div className='flex flex-col min-h-displayNoNavHt items-center justify-center text-center bg-slate-300 '> */}  
              {/* <div id="scrollWrapper2" className="overflow-y-auto overflow-x-hidden w-full h-screen relative">         */}
              <SlideFull id="slide1" className="" >
                
                <MediaBackground url={props.media.background_cultural} poster={props.media.background_cultural_poster} spinner={null} npreloader={true} preloadCB={updatePreloadCounter} overlay={isContrast ? props.media.overlay : null}/> 
                {/* <div id="scrollWrapper" className="overflow-y-auto w-full h-screen relative">  */}
                {getValidIndexRange(customSlideEventIndex, 1) ? <>
                {/* <div className='absolute top-0 bg-red-900'>TOP?</div> */}
                {/* <div id="scrollWrapper" className="overflow-y-auto w-full h-screen relative ">  */}
                <div className='max-w-[50rem] z-10 pr-[2rem] md:pr-[3rem] lg:pr-[3rem] xl:pr-[3rem] 2xl:pr-[3rem] pl-[2rem] mb-[8rem]' >
                    <div className='flex flex-row flex-wrap items-center justify-center animate-slidexFadeinDelayA '>
                      <img className="mb-5 md:mb-10 w-[4rem] md:w-[6rem]" src={ !isAnimationPaused ? culturalIcon : culturalIconPause} alt="Cultural icon" width={100} height={100} />
                    </div>
                    <h1 className="text-4xl md:text-4xl lg:text-6xl xl:text-6xl 2xl:text-6xl font-bold animate-slidexFadeinDelayB">
                    {/* Cultural features     */}
                    {/* {slidesScrollerRef && slidesScrollerRef.current.getCurrentSlideIndexFromControlsMod()} */}
                      {FEATURES.CULTURAL}    
                    </h1>
                    <p className='font-bold mt-6 text-lg animate-slidexFadeinDelayC'>
                      {getCulturalFeaturesDescription()}
                    </p>
                    {/* <div className="mt-9 font-bold flex flex-row flex-wrap items-center justify-center"> */}
                    {/* <ButtonTextIcon text="Scroll down" icon={scrollDownIcon} iconSize="18" onClick={() => slidesScrollerRef.current.gotoNextSlideMod()}/> */}
                    {/* </div> */}
                </div>
                {/* </div> */}
                </> : 
                <div className='absolute h-full w-screen'>
                  {/* <Spinner icon={props.spinner}/> */}
                </div>}
                {/* </div> */}
              </SlideFull>
              {/* </div>   */}

              {/* media gallery slides: cultural size of images need to be 556x384 or they get cropped/filled to width */}
              {/* <SlideFull id="slide4" className="bg-slate-500">
                <MediaBackground url={props.media.background}  /> 
                <GalleryItemDetail></GalleryItemDetail>
              </SlideFull> */}

              {
                getCulturalFeaturesGalleryData().map((item, index) =>
                  
                  <SlideFull ref={(index == 0) ? element3Ref : null} key={index} className="!justify-start md:!justify-center lg:!justify-center xl:!justify-center 2xl:!justify-center " id={getCulturalFeaturesGalleryId(index)}>
                    {/* <MediaBackground url={props.media.background} poster={null} />  */}
                    {/* <div id="scrollWrapper" className="overflow-y-auto w-full h-screen relative">  */}
                    {getValidIndexRange(customSlideEventIndex, index+2) ? 
                    <GalleryItemDetail data={item} subhead={FEATURES.CULTURAL} note={MEDIA.FIVE.note_feature_cultural} onZoom={onZoomOpenEvent} spinner={props.spinner} ></GalleryItemDetail>
                    : 
                    <div className='absolute h-full w-screen'>
                      {/* <Spinner /> */}
                      {/* <PreloadedImage data={item}></PreloadedImage> */}
                    </div>
                    }
                    {/* </div> */}
                    </SlideFull>
                    
                )
              }

              {/* <SlideFull id="slide2" >
                <MediaBackground url={props.media.background}  /> 
                <div className='max-w-[50rem] z-10' >
                    <h1 className="text-6xl font-bold">
                      {FEATURES.CULTURAL} 2   
                    </h1>
                    <p className='font-bold mt-6'>
                      {getCulturalFeaturesDescription()}
                    </p>
                    <div className="mt-9 font-bold flex flex-row flex-wrap items-center justify-center">
                    <ButtonTextIcon text="Scroll down" icon={scrollDownIcon} iconSize="18" onClick={() => slidesScrollerRef.current.gotoNextSlideMod()}/>
                    </div>
                </div>
              </SlideFull> */}

              


              <SlideFull id={getSecurityFeaturesGalleryHomeId()} className="">
                
                <MediaBackground url={props.media.background_security} poster={props.media.background_security_poster} spinner={null} npreloader={true} preloadCB={updatePreloadCounter} overlay={isContrast ? props.media.overlay : null}/> 
                {getValidIndexRange(customSlideEventIndex, getSecurityFeaturesGalleryHomeIndex()) ? <>
                {/* <div className='absolute top-0 bg-red-900'>TOP?</div> */}
                <div className='max-w-[50rem] z-10 pr-[2rem] md:pr-[3rem] lg:pr-[3rem] xl:pr-[3rem] 2xl:pr-[3rem] pl-[2rem] mb-[8rem]' >
                    <div className='flex flex-row flex-wrap items-center justify-center animate-slidexFadeinDelayA '>
                      <img className="mb-5 md:mb-10 w-[4rem] md:w-[6rem]" src={!isAnimationPaused ? securityIcon : securityIconPause} alt="Security icon" width={100} height={100} />
                    </div>
                    <h1 className="text-4xl md:text-4xl lg:text-6xl xl:text-6xl 2xl:text-6xl font-bold animate-slidexFadeinDelayB">
                    {/* Design and security features         */}
                    {FEATURES.SECURITY} 
                    </h1>
                    <p className='font-bold mt-6 text-lg animate-slidexFadeinDelayC'>
                    {getSecurityFeaturesDescription()}
                    </p>
                    {/* <div className="mt-9 font-bold flex flex-row flex-wrap items-center justify-center"> */}
                    {/* <ButtonTextIcon text="Scroll down" icon={scrollDownIcon} iconSize="18" onClick={() => slidesScrollerRef.current.gotoNextSlideMod()}/> */}
                    {/* </div> */}
                </div>
                </> : 
                <div className='absolute h-full w-screen'>
                  {/* <Spinner icon={props.spinner}/> */}
                </div>}
              </SlideFull>

              {/* media gallery slides: security */}
              {
                getSecurityFeaturesGalleryData().map((item, index) => 
                  <SlideFull key={index} className="!justify-start md:!justify-center lg:!justify-center xl:!justify-center 2xl:!justify-center" id={getSecurityFeaturesGalleryId(index)}>
                    {/* <MediaBackground url={props.media.background}  poster={null}/>  */}
                    {/* onClick={() => slidesScrollerRef.current.gotoNextSlideMod()} */}
                    {/* <div id="scrollWrapper" className="overflow-y-auto w-full h-screen relative">  */}
                    {getValidIndexRange(customSlideEventIndex, index+getSecurityFeaturesGalleryHomeIndex()+1) ?
                    <GalleryItemDetail data={item} subhead={FEATURES.SECURITY} note={MEDIA.FIVE.note_feature_security} onZoom={onZoomOpenEvent} spinner={props.spinner} ></GalleryItemDetail>
                    : 
                    <div className='absolute h-full w-screen'>
                      {/* <Spinner /> */}
                      {/* <PreloadedImage data={item}></PreloadedImage> */}
                    </div>
                    }
                    {/* </div> */}
                  </SlideFull>
                )
              }
              {/* <SlideFull id="slide4" className="bg-slate-500">
                <MediaBackground url={props.media.background}  /> 
                <GalleryItemDetail></GalleryItemDetail>
              </SlideFull> */}

 

              {/*  */}
              <SlideFull id={getLastId()} className="!justify-start md:!justify-center lg:!justify-center xl:!justify-center 2xl:!justify-center">
                {/* <div id="scrollWrapper" className="overflow-y-auto overflow-x-hidden w-full h-screen relative"> */}
                <MediaBackground url={props.media.background_clouds}  poster={props.media.background_clouds_poster} spinner={null} npreloader={true} overlay={isContrast ? props.media.overlay : null}/> 
                {getValidIndexRange(customSlideEventIndex, getSecurityFeaturesGalleryCount()-1) ? <>
                <div className='max-w-[75rem] z-10 py-[5rem] md:py-[0rem]' >
                      <h1 className="text-4xl md:text-4xl lg:text-6xl xl:text-6xl 2xl:text-6xl font-bold mb-10 animate-slidexFadeinDelayA">
                      Explore another banknote        
                      </h1>
                      <div className='flex flex-wrap justify-center gap-x-5 gap-y-2 font-bold animate-slidexFadeinDelayB'>
                        { props.note != SECTIONS.FIVE &&
                          <Link to="/five" className={cnNoteSize}>
                              {/* <img className={cnGrayscaleFilters} src={MEDIA.FIVE.note_choose} alt="$5 Banknote"  /> */}
                              <img className="" src={MEDIA.FIVE.note_choose} alt="$5 Banknote"  />
                              <h5 className="text-2xl leading-[3rem]">$5 Banknote</h5>
                          </Link>
                        }
                        { props.note != SECTIONS.TEN &&
                          <Link to="/ten" className={cnNoteSize}>
                            <img className="" src={MEDIA.TEN.note_choose} alt="$10 Banknote" width={360} height={180} />
                              <h5 className="text-2xl leading-[3rem]">$10 Banknote</h5>
                          </Link>
                        }
                        { props.note != SECTIONS.TWENTY &&
                          <Link to="/twenty" className={cnNoteSize}>
                          <img className="" src={MEDIA.TWENTY.note_choose} alt="$20 Banknote" width={360} height={180} />
                            <h5 className="text-2xl leading-[3rem]">$20 Banknote</h5>
                        </Link>
                        }
                        { props.note != SECTIONS.FIFTY &&
                        <Link to="/fifty" className={cnNoteSize}>
                          <img className="" src={MEDIA.FIFTY.note_choose} alt="$50 Banknote" width={360} height={180} />
                            <h5 className="text-2xl leading-[3rem]">$50 Banknote</h5>
                        </Link>
                        }
                        { props.note != SECTIONS.HUNDRED &&
                        <Link to="/hundred" className={cnNoteSize}>
                          <img className="" src={MEDIA.HUNDRED.note_choose} alt="$100 Banknote" width={360} height={180} />
                            <h5 className="text-2xl leading-[3rem]">$100 Banknote</h5>
                        </Link>
                        }
                        
                      </div>
                      <div className={cnBottomBuffer}></div>
                  </div>
                  </>: 
                <div className='absolute h-full w-screen'>
                  {/* <Spinner icon={props.spinner}/> */}
                </div>}
                {/* </div> */}
            </SlideFull>
          </SlidesScroller>

          {/* preloaded gallery content: cultural gallery + security gallery 1st images ONLY. once all items preloaded then hide from dom: visible fixed top-0 */}
          <div className={((isPreloading) ? '' : 'hidden') + ' invisible top-0 height-0'} id="preloadedgalleryitems">
            {
              getSecurityFeaturesGalleryData().map((item, index) => 
                <PreloadedGalleryItemDetail data={item} key={"a_"+index} preloadCB={updatePreloadCounter}></PreloadedGalleryItemDetail>
              )
            }
            {
              getCulturalFeaturesGalleryData().map((item, index) =>
                <PreloadedGalleryItemDetail data={item} key={"b_"+index} preloadCB={updatePreloadCounter} ></PreloadedGalleryItemDetail>
              )
            }
            {/* {
              <PreloadedImages preloadCB={updatePreloadCounter} images={[MEDIA.FIVE.note_choose,MEDIA.TEN.note_choose,MEDIA.TWENTY.note_choose,MEDIA.FIFTY.note_choose,MEDIA.HUNDRED.note_choose]}></PreloadedImages>
            } */}
          </div>

          {/* {!isZoom &&  */}
            <Footer onScrollDownClick={() => slidesScrollerRef.current.gotoNextSlideMod()} slideCount={getTotalSlidesCount()} onScrollUpClick={() => slidesScrollerRef.current.gotoPrevSlideMod()} onCreditsClick={onCreditsOpenEvent}/>
          {/* } */}
          { isZoom && 
            <ModalOverlay onModalClose={onZoomCloseEvent} fullscreen={true} mediaFilename={zoomItem.filename}>     
                <MediaItem                
                  src={zoomItem.filename}                  
                  caption={zoomItem.caption}
                  credit={zoomItem.credit}
                  subtitles={zoomItem.subtitle_url}
                  spinner={props.spinner}
                  alt={zoomItem.alttext}
                />
            </ModalOverlay>
          }
          { isHelp &&
          <ModalOverlay onModalClose={onHelpClosed} fullscreen={false}> 
              {/* safar ios bug: https://v2.tailwindcss.com/docs/upgrading-to-v2#the-scrolling-touch-and-scrolling-auto-utilities-have-been-removed */}
            
            <div className='my-0 mx-0 px-14 py-14 text-left max-h-full overflow-y-auto scrolling-touch'>
              <h1 className="text-4xl md:text-6xl lg:text-6xl xl:text-6xl 2xl:text-6xl font-bold mb-6">
                {props.helpData.title}      
              </h1>
              <p className='my-6 text-lg'>{ parse(props.helpData.description) }</p>
              <div id="bottomGradient" className="absolute block h-20 w-full px-14 z-10 bottom-0 left-0">
                <div className="h-full w-full bg-gradient-to-t from-rba-gray-options to-rba-gray-options-alpha"></div>
              </div>
            </div>
          </ModalOverlay>
    }

        </>
        }
        </div>

      </div>

        {/* { isCredits &&
          <ModalOverlay onModalClose={onCreditsCloseEvent} fullscreen={false}>     
            <div className='my-0 mx-0 px-14 py-14 text-left max-h-full overflow-y-auto'>
              <h1 className="text-4xl md:text-6xl lg:text-6xl xl:text-6xl 2xl:text-6xl font-bold mb-6">
                Background credits       
              </h1>
              <h5 className="font-bold text-2xl">{getBackgroundCredits('title')}</h5>
              <p className='mt-6 text-lg'>{getBackgroundCredits('text')}</p>
              <p className='mt-6 text-lg'>{getBackgroundCredits('text')}</p>
              <p className='mt-6 text-lg'>{getBackgroundCredits('text')}</p>
              <div id="bottomGradient" className="absolute block h-10 w-full px-14 z-10 bottom-0 left-0">
                <div className="h-full w-full bg-gradient-to-t from-rba-gray to-transparent "></div>
              </div>
            </div>
          </ModalOverlay>
        } */}

        {/* <Footer onScrollDownClick={() => slidesScrollerRef.current.gotoNextFullPageMod()}/> */}
    </>
  )
}

// export default ScrollerSlides 
// export default {
//   ScrollerSlides
// }